const API = process.env.REACT_APP_API_BASE_URL || '';

export const PointsService = {
    async getAllBalances(authorizedFetch) {
        const res = await authorizedFetch(`${API}/api/points/balances`);
        if (!res.ok) throw new Error('Failed to fetch point balances');
        return res.json(); // { ownerId: balance }
    },

    async getBalance(authorizedFetch, ownerId) {
        const res = await authorizedFetch(`${API}/api/points/balance/${ownerId}`);
        if (!res.ok) throw new Error('Failed to fetch balance');
        return res.json(); // { ownerId, balance }
    },

    async getHistory(authorizedFetch, ownerId) {
        const res = await authorizedFetch(`${API}/api/points/history/${ownerId}`);
        if (!res.ok) throw new Error('Failed to fetch history');
        return res.json();
    },

    async redeem(authorizedFetch, { ownerId, points, note }) {
        const res = await authorizedFetch(`${API}/api/points/redeem`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ownerId, points, note }),
        });
        if (!res.ok) {
            const data = await res.json().catch(() => ({}));
            throw new Error(data.error || 'Failed to redeem points');
        }
        return res.json();
    },
};
